import { render } from "./LobbyNew.vue?vue&type=template&id=fee5dc7a&scoped=true"
import script from "./LobbyNew.vue?vue&type=script&lang=js"
export * from "./LobbyNew.vue?vue&type=script&lang=js"

import "./LobbyNew.vue?vue&type=style&index=0&id=fee5dc7a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fee5dc7a"]])

export default __exports__